import React from 'react';

export const User = React.createContext({
    rol: null,
    avatar: null,
    reloadUser: null,
    userName: null,
    points: null,
    isAnimationOn: null,
});